import { render, staticRenderFns } from "./CRMTeam.vue?vue&type=template&id=5dc1db6c&scoped=true&"
import script from "./CRMTeam.vue?vue&type=script&lang=js&"
export * from "./CRMTeam.vue?vue&type=script&lang=js&"
import style0 from "./CRMTeam.vue?vue&type=style&index=0&id=5dc1db6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1db6c",
  null
  
)

export default component.exports